export default {"src":"/_next/static/image/public/images/ic_under_review.f2b7b76a2597bb41a18e4b177b9064f5.svg","height":160,"width":129};